
















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button } from 'vant';
import SearchInput from './SearchInput.vue';
import VoteButton from './VoteButton.vue';
import { ProgramList, PersonalList, ProgramTree } from '../api';
import PickerInput from '@/components/PickerInput.vue';
Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Button);
@Component({
  components: {
    SearchInput,
    VoteButton,
    PickerInput,
  },
})
export default class VoteList extends Vue {
  @Prop() listType!: any;
  @Prop() options!: any;

  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];
  SearchData = '';
  programList: any[] = [];
  searchType = 0;
  // 初使加载
  created() {
    console.log('object', this.$route);
    if (this.listType === 'program') {
      ProgramList(this.options.voteName).then((res: any) =>
        this.fetchListData(res),
      );
    } else if (this.listType === 'personal') {
      PersonalList(this.options.voteName).then((res: any) =>
        this.fetchListData(res),
      );
    }
    ProgramTree(this.options.voteName).then((res: any) => {
      const NewProgram: any[] = [{ text: '全部', id: 0 }];
      res.data.map((item: any) => {
        NewProgram.push({ text: item.title, id: item.id });
      });
      this.programList = NewProgram;
    });
  }
  fetchListData(res: any) {
    this.getListData = res.data;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    console.log();
    this.$router.push({
      path: './Detail',
      query: { id: item.id, type: this.$route.name },
    });
    // this.$emit('enterDetailPage', item.id);
  }
  fetchSearch(e: any) {
    this.SearchData = e;
  }
  // 开始搜索
  startSearch() {
    PersonalList(this.options.voteName, this.SearchData, 0).then((res: any) =>
      this.fetchListData(res),
    );
  }
  selectPickerData(e: any) {
    this.searchType = e.id;
    PersonalList(this.options.voteName, '', e.id).then((res: any) =>
      this.fetchListData(res),
    );
  }
}
